import React, { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Form, Col, Row, ButtonGroup, Button } from 'react-bootstrap'
import { api, get, getBranchOwner, put, post } from "@config"
import { notification } from 'antd'
import { checkIfBranchExists } from '../../../../utils'


function SalesConfig(props) {
    checkIfBranchExists()
    const branch = getBranchOwner().id

    const [loading, setLoading] = useState(false)

    const [id, setId] = useState(null)
    const [automaticPrint, setAutomaticSalePrint] = useState(false)
    const [registerUserOnsale, setRegisterUser] = useState(false)
    const [printLayout, setPrintLayout] = useState(1)
    const [printOrientation, setPrintOrientation] = useState(1)
    const [returnProductsToStock, setReturnProducts] = useState(false)
    const [couponMessage, setCouponMessage] = useState("")
    const [message, setMessage] = useState('')

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            const payload = config => {
                setId(config.id)
                setPrintLayout(config.print_layout)
                setAutomaticSalePrint(config.automatic_print)
                setRegisterUser(config.register_user_on_sale)
                setPrintOrientation(config.default_print_orientation)
                setReturnProducts(config.return_products_to_stock)
                setCouponMessage(config.coupon_message)
                setLoading(false)
            }
            get(`${api.branchSettings}?branch_owner=${branch}`, payload, (e) => setLoading(false))
        }, 250)
    }, [])

    function save(e) {
        e.preventDefault()
        setLoading(true)
        const data = {
            branch_owner: branch,
            automatic_print: automaticPrint,
            coupon_message: null,
            default_print_orientation: printOrientation,
            print_layout: printLayout,
            register_user_on_sale: registerUserOnsale,
            return_products_to_stock: returnProductsToStock
        }
        const payload = response => {
            setLoading(false)
            notification.open({
                message: "Atualizado com sucesso",
                type: "success",
                key: 2,
                duration: 3
            })
        }

        const errorPayload = err => {
            notification.open({
                message: "Erro ao atualizar",
                type: "warning",
                key: 2,
                duration: 3
            })
            setLoading(false)
        }

        if (!id) {
            post(`${api.branchSettings}?branch_owner=${branch}`, data, payload, errorPayload)
        } else {
            put(`${api.branchSettings}${id}/?branch_owner=${branch}`, data, payload, errorPayload)
        }
    }

    function toggleClickValue(e, payload) {
        const { value } = e.target
        payload(value === "true")
    }

    function setAutomaticPrint(e) {
        toggleClickValue(e, setAutomaticSalePrint)
    }
    function toggleRegisterUserOnSale(e) {
        toggleClickValue(e, setRegisterUser)
    }
    function toggleReturnProductsToStock(e) {
        toggleClickValue(e, setReturnProducts)
    }
    const ButtonsToggle = props => <React.Fragment>
        <ButtonGroup>
            {
                props.buttons.map(button => <Button
                    disabled={loading}
                    onClick={setAutomaticSalePrint}
                    value={button.value}
                    active={button.active}
                    size="sm px-2 ">
                    <i className={`fas ${automaticPrint ? button.icon : ''}`}></i> Sim
                </Button>)
            }
        </ButtonGroup>
    </React.Fragment>

    return <React.Fragment>
        <h2 className="p-0">Configurações de vendas</h2>
        <Form onSubmit={save}>
            <Row>
                <Col md={6} className="py-2">
                    <p className="p-0">Impressão automática da venda ao finalizar a venda?</p>
                    <ButtonGroup>
                        <Button
                            disabled={loading}
                            onClick={setAutomaticPrint}
                            value={false}
                            variant={`${!automaticPrint ? 'danger' : 'secondary'}`}
                            active={!automaticPrint}
                            size="sm">
                            <i className={`fas ${!automaticPrint ? 'fa-close' : ''}`}></i> Não
                        </Button>&nbsp;&nbsp;
                        <Button
                            disabled={loading}
                            onClick={setAutomaticPrint}
                            value={true}
                            active={automaticPrint}
                            variant={`${!automaticPrint ? 'secondary' : 'primary'}`}
                            size="sm px-2 ">
                            <i className={`fas ${automaticPrint ? 'fa-check' : ''}`}></i> Sim
                        </Button>
                    </ButtonGroup>
                    <hr />
                </Col>
                <Col md={6} className="py-2">
                    <Form.Label>Defina a orientação padrão da impressão {couponMessage}</Form.Label>
                    <Form.Control
                        disabled={loading}
                        value={printOrientation}
                        onChange={e => setPrintOrientation(Number(e.target.value))}
                        as="select">
                        <option value={1}>Retrato</option>
                        <option value={2}>Paisagem</option>
                    </Form.Control>
                </Col>
                <hr />
                <Col md={6} className="py-2">
                    <p>Defina o formato padrão de impressão da venda</p>
                    <select
                        disabled={loading}
                        value={printLayout}
                        className="form-control"
                        onChange={e => setPrintLayout(Number(e.target.value))}
                    >
                        <option value={1}>A4</option>
                        <option value={2}>80x80 (Não fiscal)</option>
                    </select>
                    <hr />
                </Col>

                <Col md={6} className="py-2">
                    <p>Retornar produtos ao estoque quando cancelar venda?</p>
                    <ButtonGroup>
                        <Button
                            disabled={loading}
                            onClick={toggleReturnProductsToStock}
                            value={false}
                            variant={`${!returnProductsToStock ? 'danger' : 'secondary'}`}
                            active={!returnProductsToStock}
                            size="sm">
                            <i className={`fas ${!returnProductsToStock ? 'fa-close' : ''}`}></i> Não
                        </Button>&nbsp;&nbsp;
                        <Button
                            disabled={loading}
                            onClick={toggleReturnProductsToStock}
                            value={true}
                            active={returnProductsToStock}
                            variant={`${!returnProductsToStock ? 'secondary' : 'primary'}`}
                            size="sm px-2 ">
                            <i className={`fas ${returnProductsToStock ? 'fa-check' : ''}`}></i> Sim
                        </Button>
                    </ButtonGroup>
                    <hr />
                </Col>
                <hr />
                <Col md={6} className="py-2">
                    <p>Habilitar cadastro de cliente na venda?</p>
                    <ButtonGroup>
                        <Button
                            disabled={loading}
                            onClick={toggleRegisterUserOnSale}
                            value={false}
                            variant={`${!registerUserOnsale ? 'danger' : 'secondary'}`}
                            active={!registerUserOnsale}
                            size="sm">
                            <i className={`fas ${!registerUserOnsale ? 'fa-close' : ''}`}></i> Não
                        </Button>&nbsp;&nbsp;
                        <Button
                            disabled={loading}
                            onClick={toggleRegisterUserOnSale}
                            value={true}
                            active={registerUserOnsale}
                            variant={`${!registerUserOnsale ? 'secondary' : 'primary'}`}
                            size="sm px-2 ">
                            <i className={`fas ${registerUserOnsale ? 'fa-check' : ''}`}></i> Sim
                        </Button>
                    </ButtonGroup>
                    <hr />
                </Col>
                <Col md={6} className="py-2">
                    <p>Mensagem de Agradecimento</p>
                    <Form.Control
                        disabled={loading}
                        value={message}
                        onChange={e => setMessage(e.target.value)}
                        as="textarea" />
                    <hr />
                </Col>

            </Row>
            <Row className="">
                <Col md={12} xs={12} className="mx-auto">
                    <ButtonGroup>
                        <Button
                            variant="danger"
                            onClick={() => window.history.back()}>
                            Cancelar
                        </Button>&nbsp;&nbsp;
                        <Button
                            disabled={loading}
                            type="submit">
                            Salvar
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
        </Form>
    </React.Fragment>
}

const mapStateToProps = state => ({
})
const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SalesConfig)


// WEBPACK FOOTER //
// ./src/components/pages/settings/sale-config/index.jsx